import tags from './tags-movies.json'

export function getTagName(tag) {
    return tags[tag] || null;
}